var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMistOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "102px",
    viewBox: "0 0 101 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mist_off",
    fill: "#9FACF8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path4202",
    points: "99.334743 50 100.334743 50 100.334743 40.1 100.334743 40 75.584743 0.4 75.334743 0 25.83474 0 25.33474 0 0.58474 39.6 0.33474 40 0.33474 49.9 0.33474 50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4750",
    x: 0.33474,
    y: 53.8983,
    width: 100.000003,
    height: 7.4576268
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4792",
    transform: "translate(20.881351, 66.404445)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path4755",
    cx: 7.54662,
    cy: 7.72881,
    r: 7.2245755
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle4788",
    cx: 28.98729,
    cy: 7.72881,
    r: 7.2245755
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle4790",
    cx: 51.36017,
    cy: 7.72881,
    r: 7.2245755
  })), /*#__PURE__*/React.createElement("circle", {
    id: "circle4799",
    cx: 16.57466,
    cy: 93.88878,
    r: 7.2245755
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle4801",
    cx: 38.70511,
    cy: 93.88878,
    r: 7.2245755
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle4803",
    cx: 60.83553,
    cy: 93.88878,
    r: 7.2245755
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle4808",
    cx: 82.965973,
    cy: 93.88878,
    r: 7.2245755
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistOn);
export default __webpack_public_path__ + "static/media/mist_on.8cfe92be1b9b0841bae6bbbab9e44816.svg";
export { ForwardRef as ReactComponent };